const COMMENTS = [
  {
    id: 1,
    name: '影视爱好者小王',
    text: '用了51视频大半年了，真的良心平台。画质清晰，加载速度飞快，最重要的是完全免费！每天下班回家打开就能看，更新也特别及时，最新的电影电视剧都能第一时间看到。强烈推荐给身边所有朋友。',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20in%20warm%20coral%20tones%2C%20abstract%20geometric%20style%2C%20dark%20background%2C%20no%20text&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '追剧达人小李',
    text: '手机App体验非常棒，离线缓存功能太实用了，每天通勤路上看两集剧，流量消耗也不大。画质从流畅到4K可以自由切换，在地铁上信号不好的时候切成流畅模式照样看得很舒服。希望51视频越做越好。',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20in%20warm%20amber%20tones%2C%20abstract%20geometric%20style%2C%20dark%20background%2C%20no%20text&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '电影发烧友老张',
    text: '作为一个看了十几年电影的老影迷，51视频的片库真的让我惊喜。很多冷门佳片和经典老片都能找到，纪录片频道的内容质量也特别高。没有广告没有收费，在现在的互联网环境下简直是一股清流。',
    time: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20avatar%20in%20warm%20terracotta%20tones%2C%20abstract%20geometric%20style%2C%20dark%20background%2C%20no%20text&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">用户评价</h2>
          <p className="text-sm text-foreground-500 mt-2">听听用户们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              {/* Text */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">{comment.text}</p>
              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-9 h-9 rounded-full object-cover bg-background-100"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}